import { RouterModule, Routes } from '@angular/router';

import { CourseViewComponent } from 'src/app/course-view/course-view.component';
import { HelpPageComponent } from 'src/app/help-page/help-page.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'faq', component: HelpPageComponent },
      { path: ':alias', component: CourseViewComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseViewRoutingModule { }
